export const INIT = 'GLOBAL::INIT'

export function init() {
  return {
    type: INIT,
  }
}
